@if (showHeader) {
  <div class="d-flex align-items-center mb-2">
  <h2 class="nav-secondary nav-font14 font-weight-bold mb-0">History</h2>
  <button type="button" class="btn btn-sm btn-link grey5 ml-auto p-0 panel-close"
          aria-label="Close history"
          (click)="closed.emit()">
    <i class="fas fa-times" aria-hidden="true"></i>
  </button>
  </div>
}

@if (loading()) {
  <p class="grey4 nav-font12 mb-0">
    <i class="fas fa-spinner fa-spin mr-1" aria-hidden="true"></i>Loading history…
  </p>
} @else if (loadFailed()) {
  <p class="grey4 nav-font12 mb-0">Couldn't load the history.</p>
} @else if (entries().length === 0) {
  <p class="grey4 nav-font12 mb-0">
    No history yet. Changes from here on will be listed, newest first.
  </p>
} @else {
  @if (disabled) {
    <p class="grey4 nav-font12 mb-2">Finish editing pages to restore a version.</p>
  }

  @if (revertFailure(); as failure) {
    <p class="history-error nav-font12 mb-2" role="alert">{{ failureMessage(failure) }}</p>
  }

  <!-- NK-450: a restore changes the draft, never the share link. Said once, up front, whenever there
       is a live version to be confused with. -->
  @if (published()) {
    <p class="grey4 nav-font12 mb-2">
      <i class="fas fa-share-nodes mr-1" aria-hidden="true"></i>
      Restoring changes this report's draft only. End clients keep seeing the live version until you
      republish.
    </p>
  }

  <!-- One row per version, newest first, read top to bottom: what kind of change and who made it
       when, then what changed -- two lines of it, the rest on request -- and the request itself only
       when asked for. Restore on the right, where the eye ends a row. -->
  <ol class="history-log list-unstyled mb-0">
    @for (entry of entries(); track entry.version) {
      <li class="history-entry" [class.is-current]="entry.isCurrent">
        <span class="history-dot" aria-hidden="true"></span>

        <div class="history-main">
          <p class="history-meta mb-1">
            <span class="history-source">{{ entry.sourceLabel }}</span>
            <span class="history-when">{{ savedByLabel(entry) }} · {{ savedAtLabel(entry) }}</span>
            @if (entry.isCurrent) {
              <span class="history-current-badge">Current</span>
            }
            @if (entry.isLive) {
              <span class="history-live"
                    [tooltip]="'The version end clients see on the share link'"
                    container="body">Live</span>
            }
          </p>

          <!-- Left out where there is no summary: the tag above already says what kind of save it
               was, and repeating it as the change says nothing more. -->
          @if (entry.summary?.trim()) {
            <p class="history-change mb-0" [class.is-clamped]="!isExpanded(entry)">{{ entry.summary }}</p>
            @if (isLong(entry)) {
              <button type="button" class="history-more btn btn-link p-0"
                      [attr.aria-expanded]="isExpanded(entry)"
                      (click)="toggleExpanded(entry)">
                {{ isExpanded(entry) ? 'Less' : 'More' }}
              </button>
            }
          }
          @if (askedFor(entry); as asked) {
            <details class="history-asked mt-1">
              <summary>What was asked</summary>
              <p class="mb-0 mt-1">“{{ asked }}”</p>
            </details>
          }
        </div>

        @if (!entry.isCurrent) {
          <button type="button"
                  class="history-restore btn btn-sm"
                  [disabled]="!canRevert(entry)"
                  [attr.aria-label]="'Restore the version from ' + savedAtLabel(entry)"
                  (click)="revert(entry)">
            @if (reverting() === entry.version) {
              <i class="fas fa-spinner fa-spin mr-1" aria-hidden="true"></i>Restoring…
            } @else {
              Restore
            }
          </button>
        }
      </li>
    }
  </ol>
}
